export default __webpack_public_path__ + "012096ec37179a1dac45c4e7da912316.svg";